export default {
      id: "ic_up_direction-usage",
      viewBox: "0 0 12 12",
      url: "/" + "images/icons.3.109.2.svg#ic_up_direction-usage",
      toString: function () {
        return this.url;
      }
    }